@if (initialized$ | async) {
	<input
		class="c-input c-input--as-textfield"
		#primaryInput
		#input
		type="text"
		matInput
		[placeholder]="placeholder"
		[formControl]="form"
		[matAutocomplete]="auto"
	/>
	<mat-autocomplete
		#auto="matAutocomplete"
		[hideSingleSelectionIndicator]="true"
		(optionSelected)="valueSelected.emit($event)"
	>
		@for (option of options; track option) {
			<mat-option [value]="option.value">
				{{ option.label }}
			</mat-option>
		}
	</mat-autocomplete>
}
